import { render, staticRenderFns } from "./IconComment.vue?vue&type=template&id=a13bfe86"
import script from "./IconComment.vue?vue&type=script&lang=js"
export * from "./IconComment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports